import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiPreviewCardState } from '@euler/model/bi/change-set';
import { ReactNode, memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { BiTag } from '../../components/ui/BiTag';

const kMarks: Partial<
  Record<BiPreviewCardState, { label: string; color: string }>
> = {
  [BiPreviewCardState.Added]: { label: '将添加', color: aiColors.green },
  [BiPreviewCardState.Updated]: { label: '将修改', color: aiColors.amber },
  [BiPreviewCardState.Moved]: { label: '将移动', color: aiColors.blue },
};

/** A card in the preview, outlined and tagged by what will happen to it. */
export const GhostCardFrame = memo(
  ({
    state,
    children,
  }: {
    state: BiPreviewCardState | undefined;
    children: ReactNode;
  }) => {
    const { rpx } = useResponsiveContext();
    const mark = state ? kMarks[state] : undefined;
    if (!mark) return <>{children}</>;
    return (
      // Fills a slot taller than the card, as the card itself does.
      <View style={{ flexGrow: 1 }}>
        {children}
        <View
          pointerEvents="none"
          style={[
            StyleSheet.absoluteFill,
            {
              borderRadius: rpx(14),
              borderWidth: 2,
              borderStyle: 'dashed',
              borderColor: mark.color,
              backgroundColor:
                state === BiPreviewCardState.Added
                  ? 'rgba(255,255,255,0.25)'
                  : 'transparent',
            },
          ]}
        />
        <View
          pointerEvents="none"
          style={{ position: 'absolute', top: rpx(-9), right: rpx(12) }}
        >
          <View
            style={{ backgroundColor: aiColors.card, borderRadius: rpx(10) }}
          >
            <BiTag text={mark.label} color={mark.color} />
          </View>
        </View>
      </View>
    );
  },
);
